export enum MachineType {
    None = 0,
    Vehicle = 1,
    Implement = 2
}